class MinerwaManifesto extends HTMLElement {
  connectedCallback() {
    this.observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        this.dataset.revealed = 'true';
        this.observer.disconnect();
      },
      { rootMargin: '-100px' },
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

if (!customElements.get('minerwa-manifesto')) {
  customElements.define('minerwa-manifesto', MinerwaManifesto);
}
